function promise(...args) {
	return new Promise(...args);
}

promise.all = Promise.all.bind(Promise);
promise.reject = Promise.reject.bind(Promise);
promise.resolve = Promise.resolve.bind(Promise);
promise.race = Promise.race.bind(Promise);

promise.props = function props(obj) {
	/*
	Returns a promise for an object containing the results of the promises stored
	in the values of the passed in object. If any promise in the object rejects,
	the returned promise is rejected with the rejection reason.

	promise.props({
		foo: api('/foo'),
		bar: api('/bar'),
	})
	*/
	const keys = Object.keys(obj);
	const values = keys.map(k => obj[k]);
	return promise.all(values).then(function(resolved) {
		const result = {};
		keys.forEach((k, i) => result[k] = resolved[i]);
		return result;
	});
};

export default promise;



/** WEBPACK FOOTER **
 ** core/client/rawr/utils/promise.js
 **/